var React = require('react');

function ShapesSquareInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.834259","y":"1.11691","width":"301.356","height":"301.356","stroke":"#FF00FF"}));
}

ShapesSquareInline.defaultProps = {"viewBox":"0 0 303 303","fill":"none"};

module.exports = ShapesSquareInline;

ShapesSquareInline.default = ShapesSquareInline;
